import { render, staticRenderFns } from "./buddyManagement.vue?vue&type=template&id=e47a6a4c&"
import script from "./buddyManagement.vue?vue&type=script&lang=js&"
export * from "./buddyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports